var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnicalSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcca19",
    d: "M274.106 135.128v63.695h26.187c9.485 0 17.175-7.689 17.175-17.175v-29.346c0-9.485-7.689-17.175-17.175-17.175h-26.187zM124.002 135.128v63.695H97.815c-9.485 0-17.175-7.689-17.175-17.175v-29.346c0-9.485 7.689-17.175 17.175-17.175h26.187z",
    opacity: 1,
    "data-original": "#9bc4f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3e59f",
    d: "M425.765.322h-66.184c-12.41 0-22.47 10.06-22.47 22.47v64.992c0 12.41 10.06 22.47 22.47 22.47 7.335 0 8.416 1.371 10.769 3.606h41.465c2.407-2.285 3.777-3.606 11.188-3.606h3.213v-.005c12.192-.251 21.999-10.212 21.999-22.464V22.791c0-12.403-10.049-22.458-22.45-22.469z",
    opacity: 1,
    "data-original": "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95d6a4",
    d: "M489.53.322h-67.305c12.41 0 22.47 10.06 22.47 22.47v64.992c0 12.252-9.806 22.214-21.999 22.464v.009c.102-.002.204-.004.307-.004h66.528c12.41 0 22.47-10.06 22.47-22.47V22.791C512 10.382 501.94.322 489.53.322z",
    opacity: 1,
    "data-original": "#95d6a4",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f9ff",
    d: "M477.406 46.103h-67.417a7.726 7.726 0 1 1 0-15.452h67.417a7.726 7.726 0 1 1 0 15.452zM379.923 46.103h-8.217a7.726 7.726 0 1 1 0-15.452h8.217a7.726 7.726 0 1 1 0 15.452zM477.406 82.398h-105.7a7.726 7.726 0 1 1 0-15.452h105.7a7.726 7.726 0 1 1 0 15.452z",
    opacity: 1,
    "data-original": "#f2f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffddce",
    d: "M260.309 314.703c-10.592-2.038-18.247-11.307-18.247-22.094v-61.796h-86.016v61.796c0 11.02-7.951 20.117-18.247 22.094l21.25 28.519h80.011c-.001 0 22.891-28.203 21.249-28.519z",
    opacity: 1,
    "data-original": "#ffddce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    d: "M391.926 486.499v-36.722c0-63.704-45.211-118.446-107.767-130.485-6.125-1.179-170.209 0-170.209 0C51.393 331.332 6.182 386.073 6.182 449.777v36.722z",
    opacity: 1,
    "data-original": "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaf2ff",
    d: "M277.774 312.374H57.493c-13.604 0-24.419 11.419-23.682 25.002l8.324 153.363h250.997l8.324-153.363c.737-13.584-10.078-25.002-23.682-25.002z",
    opacity: 1,
    "data-original": "#eaf2ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8f9",
    d: "M340.615 312.374H273.31c13.604 0 24.419 11.419 23.682 25.002l-8.324 153.363h67.305l8.324-153.363c.737-13.584-10.078-25.002-23.682-25.002z",
    opacity: 1,
    "data-original": "#dbe8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcca19",
    d: "M333.022 495.065v-12.682l-2.704-3.931H16.614C7.438 478.451 0 485.889 0 495.065c0 9.175 7.438 16.613 16.614 16.613h299.804c9.171-.005 16.604-7.441 16.604-16.613z",
    opacity: 1,
    "data-original": "#9bc4f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7fb2f9",
    d: "M381.494 478.451h-51.177v16.614c0 9.175-7.438 16.614-16.614 16.614h67.79c9.175 0 16.614-7.438 16.614-16.614.001-9.176-7.437-16.614-16.613-16.614z",
    opacity: 1,
    "data-original": "#7fb2f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcd6f9",
    d: "M219.784 478.451c0-13.615 5.101-26.704 14.21-36.823l.204-.228c7.449-8.334 11.978-19.333 11.978-31.39 0-17.572-9.619-32.897-23.878-40.999-2.705-1.537-6.066.396-6.066 3.508v35.057c0 5.876-4.764 10.64-10.64 10.64h-13.08c-5.876 0-10.64-4.764-10.64-10.64v-35.057c0-3.111-3.361-5.045-6.066-3.508-14.259 8.102-23.878 23.427-23.878 40.999 0 12.058 4.529 23.057 11.978 31.39l.204.228c9.109 10.119 14.21 23.208 14.21 36.823z",
    opacity: 1,
    "data-original": "#bcd6f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffddce",
    d: "M211.403 258.193c17.134-15.061 26.561-37.17 26.952-60.1l-.28-110.734c-.058-13.669-3.222-26.652-9.306-38.33a88.602 88.602 0 0 0-30.257-5.551c-44.206.688-84.16 34.468-83.957 83.18l.068 16.33.251 54.833c.569 22.411 9.964 43.945 26.836 58.524 9.976 8.62 22.909 16.419 39.031 20.023 12.295-4.312 22.471-10.975 30.662-18.175z",
    opacity: 1,
    "data-original": "#ffddce",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcbbe",
    d: "M283.16 125.938c-.161-38.694-25.662-67.888-58.495-78.298 6.996 11.834 11.111 25.763 11.175 41.212l.274 108.249c-.382 22.415-9.597 44.028-26.347 58.751-8.948 7.865-20.319 15.077-34.298 19.156 7.292 2.128 15.291 3.404 24.024 3.465 25.129-.391 44.11-10.768 57.595-22.621 16.75-14.723 25.965-36.336 26.347-58.751z",
    opacity: 1,
    "data-original": "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#756e78",
    d: "M196.128 98.44h5.853c7.944.034 15.782-1.44 23.346-3.87a42.75 42.75 0 0 1 12.761-2.053l-.013-5.158c-.065-15.181-3.959-29.517-11.432-42.158l.015.005a82.527 82.527 0 0 0-10.091-13.627l-6.747-2.278h-49.195c-36.415 0-65.936 29.52-65.936 65.936v43.574c0 6.4 4.05 12.1 10.095 14.204l16.242 5.655c5.677 1.977 11.605-2.244 11.596-8.255l-.036-30.726c-.062-14.943 11.854-27.108 26.617-27.171l.322-.002a42.758 42.758 0 0 1 13.257 2.054c7.563 2.43 15.401 3.904 23.346 3.87z",
    opacity: 1,
    "data-original": "#756e78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#665e66",
    d: "M277.71 63.693h-.866a8.684 8.684 0 0 1-8.683-8.683c0-14.199-11.51-25.709-25.709-25.709H209.82c15.737 14.523 25.918 35.149 26.019 59.55l.009 3.749c.909-.055 1.82-.088 2.734-.084l.321.002c14.763.064 26.679 12.228 26.617 27.171l-.03 30.729c-.008 6.01 5.92 10.229 11.596 8.253l16.236-5.655a15.04 15.04 0 0 0 10.094-14.204v-49.41c.002-14.199-11.508-25.709-25.706-25.709z",
    opacity: 1,
    "data-original": "#665e66",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8f9",
    d: "M302.015 198.737v11.268c0 8.777-7.14 15.917-15.917 15.917H238.53a7.726 7.726 0 1 0 0 15.452h47.568c17.297 0 31.37-14.072 31.37-31.37v-28.357c-.001 8.905-6.777 16.227-15.453 17.09z",
    opacity: 1,
    "data-original": "#dbe8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db636e",
    d: "M257.363 245.777h-19.391c-7.398 0-13.395-5.997-13.395-13.395s5.997-13.395 13.395-13.395h19.391c7.398 0 13.395 5.997 13.395 13.395s-5.997 13.395-13.395 13.395z",
    opacity: 1,
    "data-original": "#db636e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95d6a4",
    d: "m422.535 110.251-.31.002h-62.644c7.247 0 13.122 5.875 13.122 13.123v40.192c0 5.103 6.72 6.963 9.345 2.587l29.7-49.528a13.121 13.121 0 0 1 10.786-6.365v-.011z",
    opacity: 1,
    "data-original": "#95d6a4",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSupport);
export default __webpack_public_path__ + "static/media/technical-support.abb1c73371e73583bf51c362ba09e039.svg";
export { ForwardRef as ReactComponent };